import React from "react";
import { Navigate } from "react-router-dom";
import { tokenDecodeSafe } from "../../utils/helper";

interface LoginPageIsLogedInProps {
  children: React.ReactNode;
}

const LoginPageIsLogedIn = ({ children }: LoginPageIsLogedInProps) => {
  const token = localStorage.getItem("us_st_d");
  if (!token) {
    return <>{children}</>;
  }

  const decoded: any = tokenDecodeSafe(token);
  if (decoded) {
    const expirationDate = new Date(decoded?.exp * 1000);
    if (expirationDate > new Date()) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default LoginPageIsLogedIn;
